import { Sidebar as SidebarComponent, SidebarOverlay } from './styles';

export { SidebarOverlay };
export default SidebarComponent;
